var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header d-flex justify-content-between align-items-center"},[_c('h4',{staticClass:"card-header-title mb-0"},[_vm._v(_vm._s(_vm.title))]),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }